import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { MenuItems } from '../../types/MenuItems';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/settings/settings_page_1.webp';
import image2 from '../../assets/images/settings/settings_page_2.png';
import image3 from '../../assets/images/settings/settings_page_3.webp';
import image4 from '../../assets/images/settings/settings_page_4.webp';
import image5 from '../../assets/images/settings/settings_page_5.webp';

import './Settings.scss';

const images = [image1, image2, image3, image4, image5];

export const Settings = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.SETTINGS}
        title={t.SETTINGS.title}
        itemsList={t.SETTINGS.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.SETTINGS}-page-${i + 1}`,
        }))}
      />

      {t.SETTINGS.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.SETTINGS}-page-${i + 1}`}
          color={style.getPropertyValue('--violet')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
